export default __webpack_public_path__ + "static/media/endRound10.948d9ce6.mp3";